import Axios from 'axios';

export type Repo = {
  send: (endpoint: string, data: Record<string, unknown>) => Promise<void>;
};

const Repo: Repo = {
  send: async (endpoint: string, data: Record<string, unknown>) => {
    const baseUrl = import.meta.env.VITE_PUBLIC_WEB_FORM_SERVICE_API;
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    console.log(`Making request to: ${baseUrl}/${cleanEndpoint}`);

    try {
      const response = await Axios.post(`${baseUrl}/${cleanEndpoint}`, data);
      console.log('API response:', response.status, response.data);
      return response.data;
    } catch (error) {
      // Enhanced error logging
      if (Axios.isAxiosError(error)) {
        console.error('API Error Details:', {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          url: `${baseUrl}/${cleanEndpoint}`
        });
      }
      throw error;
    }
  }
};

export { Repo };

export default Repo;